module.exports = __webpack_public_path__ + "media/images/emblems/Safnern-coat_of_arms-9bbf89148d42f9863cb14371802f3e0b.svg";